import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'paymentStatus',
    standalone: true
})
export class PaymentStatusPipe implements PipeTransform {

  transform(type: string): string {
    switch (type) {
      case 'PENDING':
        return 'Pending';
      case 'REJECTED':
        return 'Rejected';
      case 'CLOSED':
        return 'Closed';
      case 'SETTLED':
        return 'Settled';
      case 'APPROVED':
        return 'Approved';
      case 'RETURNED':
        return 'Returned';
      case 'VOIDED':
        return 'Voided';
      case 'NOTICE OF CHANGE':
        return 'Needs update account information';
      default:
        return 'Unknown';
    }
  }
}
